module.exports = __webpack_public_path__ + "img/user-injured.dd59e793.svg";